var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-content", staticStyle: { "padding-top": "100px" } },
      [
        _vm.loading
          ? _c("div", { attrs: { id: "loading" } }, [
              _c("div", { staticClass: "loadingMsg" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "tabbable" }, [
              _c(
                "ul",
                {
                  staticClass:
                    "nav nav-tabs padding-12 tab-color-blue background-blue",
                  attrs: { id: "myTab4" }
                },
                [
                  _c(
                    "li",
                    { class: { active: _vm.checkActiveTab("setting1") } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            "data-toggle": "tab",
                            href: "#setting1",
                            "aria-expanded": "true"
                          },
                          on: {
                            click: function($event) {
                              _vm.changeTabActive("setting1")
                            }
                          }
                        },
                        [_vm._v("NFC読み出し位置")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.checkActiveTab("setting2") } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            "data-toggle": "tab",
                            href: "#setting2",
                            "aria-expanded": "false"
                          },
                          on: {
                            click: function($event) {
                              _vm.changeTabActive("setting2")
                            }
                          }
                        },
                        [_vm._v("キートークン有効期間")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.checkActiveTab("setting3") } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            "data-toggle": "tab",
                            href: "#setting3",
                            "aria-expanded": "false"
                          },
                          on: {
                            click: function($event) {
                              _vm.changeTabActive("setting3")
                            }
                          }
                        },
                        [_vm._v("スマートフォン自動承認")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.checkActiveTab("setting4") } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            "data-toggle": "tab",
                            href: "#setting4",
                            "aria-expanded": "false"
                          },
                          on: {
                            click: function($event) {
                              _vm.changeTabActive("setting4")
                            }
                          }
                        },
                        [_vm._v("照合ログ種別")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.checkActiveTab("setting5") } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            "data-toggle": "tab",
                            href: "#setting5",
                            "aria-expanded": "false"
                          },
                          on: {
                            click: function($event) {
                              _vm.changeTabActive("setting5")
                            }
                          }
                        },
                        [_vm._v("外部ログインサービス利用設定")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _vm.message_success
                  ? _c("div", { staticClass: "alert alert-success" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.message_success) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.message_error
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.message_error) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    class: { active: _vm.checkActiveTab("setting1") },
                    attrs: { id: "setting1" }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _c("div", { staticClass: "code" }, [
                          _c("div", { staticClass: "profile-info-row" }, [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-value" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.pCodeConfigType,
                                      expression: "settingInfor.pCodeConfigType"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { "data-placeholder": "製品名選択" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "pCodeConfigType",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.listNfcSetting1, function(item) {
                                  return _c(
                                    "option",
                                    {
                                      key: item.type,
                                      domProps: { value: item.type }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.name) +
                                          "\n                          "
                                      )
                                    ]
                                  )
                                })
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "possition" }, [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("個人ID 1 位置")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.readPosition1,
                                      expression: "settingInfor.readPosition1"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.editStatus,
                                    min: "0",
                                    max: "47"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.readPosition1
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "readPosition1",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("長さ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.readLength1,
                                      expression: "settingInfor.readLength1"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.editStatus,
                                    min: "0",
                                    max: "20"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.readLength1
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "readLength1",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("個人ID 2 位置")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.readPosition2,
                                      expression: "settingInfor.readPosition2"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.editStatus,
                                    min: "0",
                                    max: "47"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.readPosition2
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "readPosition2",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("長さ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.readLength2,
                                      expression: "settingInfor.readLength2"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.editStatus,
                                    min: "0",
                                    max: "20"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.readLength2
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "readLength2",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("個人ID 3 位置")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.readPosition3,
                                      expression: "settingInfor.readPosition3"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.editStatus,
                                    min: "0",
                                    max: "47"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.readPosition3
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "readPosition3",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("長さ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.readLength3,
                                      expression: "settingInfor.readLength3"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.editStatus,
                                    min: "0",
                                    max: "20"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.readLength3
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "readLength3",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("固定コード 1 位置")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.settingInfor.ownerCodePosition1,
                                      expression:
                                        "settingInfor.ownerCodePosition1"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.getEditStatus(),
                                    min: "0",
                                    max: "47"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCodePosition1
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCodePosition1",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("長さ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.ownerCodeLength1,
                                      expression:
                                        "settingInfor.ownerCodeLength1"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.getEditStatus(),
                                    min: "0",
                                    max: "20"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCodeLength1
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCodeLength1",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("固定コード 2 位置")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.settingInfor.ownerCodePosition2,
                                      expression:
                                        "settingInfor.ownerCodePosition2"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.getEditStatus(),
                                    min: "0",
                                    max: "47"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCodePosition2
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCodePosition2",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("長さ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.ownerCodeLength2,
                                      expression:
                                        "settingInfor.ownerCodeLength2"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.getEditStatus(),
                                    min: "0",
                                    max: "20"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCodeLength2
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCodeLength2",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("固定コード 3 位置")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.settingInfor.ownerCodePosition3,
                                      expression:
                                        "settingInfor.ownerCodePosition3"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.getEditStatus(),
                                    min: "0",
                                    max: "47"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCodePosition3
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCodePosition3",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("長さ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.ownerCodeLength3,
                                      expression:
                                        "settingInfor.ownerCodeLength3"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    disabled: _vm.getEditStatus(),
                                    min: "0",
                                    max: "20"
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCodeLength3
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCodeLength3",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "code" }, [
                          _c("div", { staticClass: "profile-info-row" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-value" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.settingInfor.isOwnerCodeValid,
                                    expression: "settingInfor.isOwnerCodeValid"
                                  }
                                ],
                                staticClass: "ace ace-switch ace-switch-4",
                                attrs: {
                                  name: "switch-field-1",
                                  type: "checkbox",
                                  disabled: _vm.editStatusException
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.settingInfor.isOwnerCodeValid
                                  )
                                    ? _vm._i(
                                        _vm.settingInfor.isOwnerCodeValid,
                                        null
                                      ) > -1
                                    : _vm.settingInfor.isOwnerCodeValid
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.settingInfor.isOwnerCodeValid,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.settingInfor.isOwnerCodeValid = $$a.concat(
                                            [$$v]
                                          ))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.settingInfor.isOwnerCodeValid = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "isOwnerCodeValid",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "lbl" })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "code" }, [
                          _c("div", { staticClass: "profile-info-row" }, [
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "profile-info-value",
                                staticStyle: {
                                  width: "450px",
                                  border: "0px solid"
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.ownerCode,
                                      expression: "settingInfor.ownerCode"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.getEditStatus()
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.ownerCode
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "ownerCode",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "felica" }, [
                          _vm._m(6),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("システムコード")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.systemCode,
                                      expression: "settingInfor.systemCode"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.checkIsMifare()
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.systemCode
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "systemCode",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-title" }, [
                                _vm._v("サービスコード")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.serviceCode,
                                      expression: "settingInfor.serviceCode"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.checkIsMifare()
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.serviceCode
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "serviceCode",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("ブロックカウント")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.blockCount,
                                      expression: "settingInfor.blockCount"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    disabled: _vm.checkIsMifare()
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.blockCount
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "blockCount",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mifare" }, [
                          _vm._m(7),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("キー種別")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "80px"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.settingInfor.keyType,
                                          expression: "settingInfor.keyType"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "key",
                                        value: "1",
                                        disabled: _vm.checkIsFalica()
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.settingInfor.keyType,
                                          "1"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.$set(
                                            _vm.settingInfor,
                                            "keyType",
                                            "1"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", [_vm._v("Aキー")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "80px"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.settingInfor.keyType,
                                          expression: "settingInfor.keyType"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "key",
                                        value: "0",
                                        disabled: _vm.checkIsFalica()
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.settingInfor.keyType,
                                          "0"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.$set(
                                            _vm.settingInfor,
                                            "keyType",
                                            "0"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", [_vm._v("Bキー")])
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("キー情報")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "profile-info-value",
                                  staticStyle: { width: "450px" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.settingInfor.keyValue,
                                        expression: "settingInfor.keyValue"
                                      }
                                    ],
                                    staticClass: "form-control input-sm",
                                    attrs: {
                                      type: "text",
                                      disabled: _vm.checkIsFalica()
                                    },
                                    domProps: {
                                      value: _vm.settingInfor.keyValue
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.settingInfor,
                                          "keyValue",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "main-title" }, [
                                _vm._v("セクタ No")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.sectorNumber,
                                      expression: "settingInfor.sectorNumber"
                                    }
                                  ],
                                  staticClass: "form-control input-sm",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.checkIsFalica()
                                  },
                                  domProps: {
                                    value: _vm.settingInfor.sectorNumber
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "sectorNumber",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "profile-info-row" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.saveNfcSetting()
                                }
                              }
                            },
                            [_vm._v("設定を保存")]
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    class: { active: _vm.checkActiveTab("setting2") },
                    attrs: { id: "setting2" }
                  },
                  [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _c("div", [
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "profile-info-name",
                                staticStyle: {
                                  width: "250px",
                                  "text-align": "left"
                                }
                              },
                              [_vm._v("オフラインでの鍵有効期間")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-value" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.settingInfor.keyTokenRefreshable,
                                    expression:
                                      "settingInfor.keyTokenRefreshable"
                                  }
                                ],
                                staticClass: "ace ace-switch ace-switch-4",
                                attrs: {
                                  name: "switch-field-1",
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.settingInfor.keyTokenRefreshable
                                  )
                                    ? _vm._i(
                                        _vm.settingInfor.keyTokenRefreshable,
                                        null
                                      ) > -1
                                    : _vm.settingInfor.keyTokenRefreshable
                                },
                                on: {
                                  change: function($event) {
                                    var $$a =
                                        _vm.settingInfor.keyTokenRefreshable,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.settingInfor.keyTokenRefreshable = $$a.concat(
                                            [$$v]
                                          ))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.settingInfor.keyTokenRefreshable = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "keyTokenRefreshable",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "lbl" })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "profile-info-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "profile-info-name",
                                staticStyle: {
                                  width: "250px",
                                  "text-align": "left"
                                }
                              },
                              [_vm._v("オフラインでの鍵有効期間")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-value" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.keyTokenLifetime,
                                      expression:
                                        "settingInfor.keyTokenLifetime"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.settingInfor,
                                        "keyTokenLifetime",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.listKeyTokenLifetime, function(
                                  item
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: item.value,
                                      domProps: { value: item.value }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.text) +
                                          "\n                          "
                                      )
                                    ]
                                  )
                                })
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "10px" } },
                          [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "profile-info-name",
                                  staticStyle: {
                                    width: "250px",
                                    "text-align": "left"
                                  }
                                },
                                [_vm._v("更新間隔")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.settingInfor.keyTokenRefreshRate,
                                        expression:
                                          "settingInfor.keyTokenRefreshRate"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.settingInfor,
                                          "keyTokenRefreshRate",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(_vm.listKeyTokenRefreshRate, function(
                                    item
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: item.value,
                                        domProps: { value: item.value }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(item.text) +
                                            "\n                          "
                                        )
                                      ]
                                    )
                                  })
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "profile-info-row" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.saveKeyToken()
                                }
                              }
                            },
                            [_vm._v("設定を保存")]
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    class: { active: _vm.checkActiveTab("setting3") },
                    attrs: { id: "setting3" }
                  },
                  [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "15px" } },
                          [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "profile-info-name",
                                  staticStyle: {
                                    width: "250px",
                                    "text-align": "left"
                                  }
                                },
                                [_vm._v("スマートフォン自動承認機能")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.settingInfor.phonesBeValid,
                                      expression: "settingInfor.phonesBeValid"
                                    }
                                  ],
                                  staticClass: "ace ace-switch ace-switch-4",
                                  attrs: {
                                    name: "switch-field-1",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.settingInfor.phonesBeValid
                                    )
                                      ? _vm._i(
                                          _vm.settingInfor.phonesBeValid,
                                          null
                                        ) > -1
                                      : _vm.settingInfor.phonesBeValid
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.settingInfor.phonesBeValid,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.settingInfor.phonesBeValid = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.settingInfor.phonesBeValid = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.settingInfor,
                                          "phonesBeValid",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "lbl" })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "profile-info-row" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.savePhoneStatus()
                                }
                              }
                            },
                            [_vm._v("設定を保存")]
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    class: { active: _vm.checkActiveTab("setting4") },
                    attrs: { id: "setting4" }
                  },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _vm.errorMessageLogs !== ""
                          ? _c("div", { staticClass: "alert alert-danger" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.errorMessageLogs) +
                                  "\n                  "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.listConfifLog != null
                          ? _c(
                              "table",
                              {
                                staticClass:
                                  "table  table-bordered table-hover dataTable",
                                attrs: { id: "simple-table" }
                              },
                              [
                                _vm._m(11),
                                _vm._v(" "),
                                _vm._l(_vm.listConfifLog, function(
                                  item,
                                  index
                                ) {
                                  return _c("tbody", { key: index }, [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticClass: "center accessLogId" },
                                        [_vm._v(_vm._s(item.accessLogId))]
                                      ),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "logLabel" }, [
                                        _vm._v(_vm._s(item.logLabel))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "center",
                                          staticStyle: { width: "110px" }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-info",
                                              on: {
                                                click: function($event) {
                                                  _vm.handleEdit(
                                                    item.accessLogId
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("編集")]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                })
                              ],
                              2
                            )
                          : _c(
                              "table",
                              {
                                staticClass:
                                  "table  table-bordered table-hover dataTable",
                                attrs: { id: "simple-table" }
                              },
                              [_vm._m(12), _vm._v(" "), _vm._m(13)]
                            ),
                        _vm._v(" "),
                        _vm.pages > 0
                          ? _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-xs-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dataTables_paginate paging_simple_numbers"
                                  },
                                  [
                                    _c("paginate", {
                                      attrs: {
                                        "page-count": _vm.pages,
                                        "page-range": 3,
                                        "margin-pages": 2,
                                        "click-handler":
                                          _vm.handleCurrentChange,
                                        "prev-text": "<<",
                                        "next-text": ">>",
                                        "container-class": "pagination",
                                        "page-class": "page-item"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    class: { active: _vm.checkActiveTab("setting5") },
                    attrs: { id: "setting5" }
                  },
                  [
                    _vm._m(14),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-prev",
                        staticStyle: { display: "none" },
                        attrs: { id: "go-setting", type: "button" },
                        on: {
                          click: function($event) {
                            _vm.goPageSetting("setting")
                          }
                        }
                      },
                      [_vm._v("戻る")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _vm.isExternalLogin === "setting"
                        ? _c("div", { staticClass: "page-content" }, [
                            _vm.loading
                              ? _c("div", { attrs: { id: "loading" } }, [
                                  _c("div", { staticClass: "loadingMsg" })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-xs-12" }, [
                                _vm.errorMessageLogs !== ""
                                  ? _c(
                                      "div",
                                      { staticClass: "alert alert-danger" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.errorMessageLogs) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.successMessageLogs !== ""
                                  ? _c(
                                      "div",
                                      { staticClass: "alert alert-success" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.successMessageLogs) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-xs-12" }, [
                                  _c("div", { staticClass: "clearfix" }, [
                                    _c(
                                      "div",
                                      { staticClass: "profile-info-row" },
                                      [
                                        _vm._m(15),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "profile-info-value" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.oneloginLoginService
                                                      .isValid,
                                                  expression:
                                                    "oneloginLoginService.isValid"
                                                }
                                              ],
                                              staticClass:
                                                "ace ace-switch ace-switch-4",
                                              attrs: {
                                                name: "switch-field-1",
                                                disabled:
                                                  _vm.isSamlFederatedLoginService ===
                                                  "false",
                                                type: "checkbox"
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.oneloginLoginService
                                                    .isValid
                                                )
                                                  ? _vm._i(
                                                      _vm.oneloginLoginService
                                                        .isValid,
                                                      null
                                                    ) > -1
                                                  : _vm.oneloginLoginService
                                                      .isValid
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.oneloginLoginService
                                                        .isValid,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.oneloginLoginService.isValid = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.oneloginLoginService.isValid = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.oneloginLoginService,
                                                      "isValid",
                                                      $$c
                                                    )
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "lbl" }),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-info btn-add",
                                                attrs: {
                                                  disabled:
                                                    !_vm.oneloginLoginService
                                                      .isResponse ||
                                                    _vm.isSamlFederatedLoginService ===
                                                      "false",
                                                  type: "button"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goRelation(
                                                      _vm.oneloginLoginService
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.lableButtonLogin
                                                      .oneLogin
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _c(
                                      "div",
                                      { staticClass: "profile-info-row" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "profile-info-name",
                                            staticStyle: {
                                              width: "156px",
                                              "text-align": "left",
                                              color: "#000",
                                              "padding-left": "0px"
                                            }
                                          },
                                          [_vm._v("メタデータURL")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "profile-info-value",
                                            staticStyle: {
                                              width: "450px",
                                              border: "0px solid"
                                            }
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.oneloginLoginService
                                                      .metadataUrl,
                                                  expression:
                                                    "oneloginLoginService.metadataUrl"
                                                }
                                              ],
                                              staticClass:
                                                "form-control input-sm",
                                              attrs: {
                                                type: "text",
                                                disabled:
                                                  !_vm.isOneloginLoginService ||
                                                  _vm.isSamlFederatedLoginService ===
                                                    "false",
                                                placeholder: "メタデータURL"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.oneloginLoginService
                                                    .metadataUrl
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.oneloginLoginService,
                                                    "metadataUrl",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      staticStyle: { "margin-bottom": "10px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-row" },
                                        [
                                          _vm._m(16),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "profile-info-value"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.googleLoginService
                                                        .isValid,
                                                    expression:
                                                      "googleLoginService.isValid"
                                                  }
                                                ],
                                                staticClass:
                                                  "ace ace-switch ace-switch-4",
                                                attrs: {
                                                  name: "switch-field-1",
                                                  disabled:
                                                    _vm.isFederatedLoginService ===
                                                    "false",
                                                  type: "checkbox"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.googleLoginService
                                                      .isValid
                                                  )
                                                    ? _vm._i(
                                                        _vm.googleLoginService
                                                          .isValid,
                                                        null
                                                      ) > -1
                                                    : _vm.googleLoginService
                                                        .isValid
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.googleLoginService
                                                          .isValid,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.googleLoginService.isValid = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.googleLoginService.isValid = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.googleLoginService,
                                                        "isValid",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "lbl"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-info btn-add",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.googleLoginService
                                                        .isResponse ||
                                                      _vm.isFederatedLoginService ===
                                                        "false",
                                                    type: "button"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.goRelation(
                                                        _vm.googleLoginService
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lableButtonLogin
                                                        .googleLogin
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      staticStyle: { "margin-bottom": "10px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-row" },
                                        [
                                          _vm._m(17),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "profile-info-value"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.appleIdLoginService
                                                        .isValid,
                                                    expression:
                                                      "appleIdLoginService.isValid"
                                                  }
                                                ],
                                                staticClass:
                                                  "ace ace-switch ace-switch-4",
                                                attrs: {
                                                  name: "switch-field-1",
                                                  disabled:
                                                    _vm.isFederatedLoginService ===
                                                    "false",
                                                  type: "checkbox"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.appleIdLoginService
                                                      .isValid
                                                  )
                                                    ? _vm._i(
                                                        _vm.appleIdLoginService
                                                          .isValid,
                                                        null
                                                      ) > -1
                                                    : _vm.appleIdLoginService
                                                        .isValid
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.appleIdLoginService
                                                          .isValid,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.appleIdLoginService.isValid = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.appleIdLoginService.isValid = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.appleIdLoginService,
                                                        "isValid",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "lbl"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-info btn-add",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.appleIdLoginService
                                                        .isResponse ||
                                                      _vm.isFederatedLoginService ===
                                                        "false",
                                                    type: "button"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.goRelation(
                                                        _vm.appleIdLoginService
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.lableButtonLogin
                                                        .appleLogin
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }, [
                                    _c(
                                      "div",
                                      { staticClass: "profile-info-row" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-info",
                                            attrs: {
                                              disabled: !_vm.allowSubmit,
                                              type: "button"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.saveConfig()
                                              }
                                            }
                                          },
                                          [_vm._v("設定を保存")]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        : _vm.isExternalLogin === "registration"
                          ? _c("div", { staticClass: "page-content" }, [
                              _vm.loading
                                ? _c("div", { attrs: { id: "loading" } }, [
                                    _c("div", { staticClass: "loadingMsg" })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-xs-12" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info btn-prev",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.goPage("setting")
                                        }
                                      }
                                    },
                                    [_vm._v("戻る")]
                                  ),
                                  _vm._v(" "),
                                  _vm.cognitoIdProviderName === "SAML"
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info btn-prev",
                                          staticStyle: { float: "right" },
                                          attrs: {
                                            disabled:
                                              _vm.isSamlFederatedLoginService ===
                                              "false",
                                            type: "button"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.goPage(
                                                "excel",
                                                _vm.cognitoIdProviderName
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" CSV一括登録 ")]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info btn-prev",
                                          staticStyle: { float: "right" },
                                          attrs: {
                                            disabled:
                                              _vm.isFederatedLoginService ===
                                              "false",
                                            type: "button"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.goPage(
                                                "excel",
                                                _vm.cognitoIdProviderName
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" CSV一括登録 ")]
                                      ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _vm.cognitoIdProviderName === "SAML"
                                    ? _c("h3", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.lableButtonLogin.oneLogin
                                            ) +
                                            "\n                      "
                                        )
                                      ])
                                    : _vm.cognitoIdProviderName === "Google"
                                      ? _c("h3", [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.lableButtonLogin.googleLogin
                                              ) +
                                              "\n                      "
                                          )
                                        ])
                                      : _vm.cognitoIdProviderName === "Apple"
                                        ? _c("h3", [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.lableButtonLogin
                                                    .appleLogin
                                                ) +
                                                "\n                      "
                                            )
                                          ])
                                        : _c("h3"),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _vm.error
                                    ? _c(
                                        "div",
                                        { staticClass: "alert alert-danger" },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(_vm.message) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.sucessStatus
                                    ? _c(
                                        "div",
                                        { staticClass: "alert alert-success" },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(_vm.message) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "input-icon search-box" },
                                    [
                                      _c("input", {
                                        staticClass: "nav-search-input",
                                        attrs: {
                                          type: "text",
                                          placeholder: "",
                                          id: "nav-search-input",
                                          autocomplete: "off"
                                        },
                                        on: {
                                          keyup: function($event) {
                                            if (
                                              !("button" in $event) &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key
                                              )
                                            ) {
                                              return null
                                            }
                                            _vm.searchExternalLogin()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "ace-icon fa fa-search nav-search-icon"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-cusstom green-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.searchExternalLogin()
                                        }
                                      }
                                    },
                                    [_vm._v("検索")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "clearfix",
                                    staticStyle: {
                                      clear: "both",
                                      "margin-bottom": "10px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table  table-bordered table-hover dataTable",
                                      attrs: { id: "relation-table" }
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { staticStyle: { width: "30%" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.cognitoIdProviderName
                                                ) + "ログインID"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticStyle: { width: "30%" } },
                                            [_vm._v("ALLIGATEユーザーID")]
                                          ),
                                          _vm._v(" "),
                                          _c("th", {
                                            staticStyle: { width: "15%" }
                                          })
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              { staticStyle: { width: "30%" } },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.newEmail,
                                                      expression: "newEmail"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-sm",
                                                  attrs: {
                                                    type: "text",
                                                    id: "new-email"
                                                  },
                                                  domProps: {
                                                    value: _vm.newEmail
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.newEmail =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticStyle: { width: "30%" } },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "multiselect",
                                                      {
                                                        attrs: {
                                                          "allow-empty": false,
                                                          id: "newUser",
                                                          options: _vm.userList,
                                                          placeholder: "",
                                                          maxHeight: 140,
                                                          label: "userId",
                                                          "custom-label":
                                                            _vm.customLabel,
                                                          "show-labels": false,
                                                          "track-by": "userId",
                                                          disabled:
                                                            _vm.isDisabled,
                                                          "tag-placeholder":
                                                            "ゲートグループの追加"
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "option",
                                                            fn: function(
                                                              props
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "option__desc"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__small"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .userId
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ]),
                                                        model: {
                                                          value: _vm.newUser,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.newUser = $$v
                                                          },
                                                          expression: "newUser"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red"
                                                            },
                                                            attrs: {
                                                              slot: "noResult"
                                                            },
                                                            slot: "noResult"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "ALLIGATEユーザーIDが見つかりません。"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "center",
                                                staticStyle: { width: "15%" }
                                              },
                                              [
                                                _vm.cognitoIdProviderName ===
                                                "SAML"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-cusstom green-btn",
                                                        staticStyle: {
                                                          padding: "5px 28px"
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.isSamlFederatedLoginService ===
                                                            "false"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.addRelation()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-plus"
                                                        }),
                                                        _vm._v("  登録")
                                                      ]
                                                    )
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-cusstom green-btn",
                                                        staticStyle: {
                                                          padding: "5px 28px"
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.isFederatedLoginService ===
                                                            "false"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.addRelation()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-plus"
                                                        }),
                                                        _vm._v("  登録")
                                                      ]
                                                    )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.realtionsUserList,
                                            function(item, index) {
                                              return _c("tr", { key: index }, [
                                                _c("td", [
                                                  !_vm.relationIdRowEditing[
                                                    item.relationId
                                                  ]
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.federatedLoginEmail
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  !_vm.relationIdRowEditing[
                                                    item.relationId
                                                  ]
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.userId)
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]),
                                                _vm._v(" "),
                                                _vm.cognitoIdProviderName ===
                                                "SAML"
                                                  ? _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        !_vm
                                                          .relationIdRowEditing[
                                                          item.relationId
                                                        ]
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn-cusstom black-btn",
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.isSamlFederatedLoginService ===
                                                                    "false"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.openConfirmModal(
                                                                      item.relationId
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("削除")]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        !_vm
                                                          .relationIdRowEditing[
                                                          item.relationId
                                                        ]
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn-cusstom black-btn",
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.isFederatedLoginService ===
                                                                    "false"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.openConfirmModal(
                                                                      item.relationId
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("削除")]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                              ])
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.pages > 0
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-12" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dataTables_paginate paging_simple_numbers"
                                              },
                                              [
                                                _c("paginate", {
                                                  attrs: {
                                                    "page-count": _vm.pages,
                                                    "page-range": 3,
                                                    "margin-pages": 2,
                                                    "click-handler":
                                                      _vm.handleCurrentChangeEx,
                                                    "prev-text": "<<",
                                                    "next-text": ">>",
                                                    "container-class":
                                                      "pagination",
                                                    "page-class": "page-item"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm.pages === 1
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "55px" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                           \n                        "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "modal fade",
                                    attrs: { id: "question", tabindex: "-1" }
                                  },
                                  [
                                    _c("div", { staticClass: "modal-dialog" }, [
                                      _c(
                                        "div",
                                        { staticClass: "modal-content" },
                                        [
                                          _vm._m(18),
                                          _vm._v(" "),
                                          _vm._m(19),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "modal-footer" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-danger pull-right",
                                                  staticStyle: {
                                                    width: "100px"
                                                  },
                                                  attrs: {
                                                    id: "yes-choice",
                                                    "data-dismiss": "modal"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.yesChoice()
                                                    }
                                                  }
                                                },
                                                [_vm._v("削除")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          : _vm.isExternalLogin === "excel"
                            ? _c(
                                "div",
                                { staticClass: "page-content register_user" },
                                [
                                  _vm.loading
                                    ? _c("div", { attrs: { id: "loading" } }, [
                                        _c("div", { staticClass: "loadingMsg" })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info btn-prev",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.goPage(
                                            "registration",
                                            _vm.cognitoIdProviderName
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("戻る")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.cognitoIdProviderName) +
                                        " ログインユーザー 一括登録"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _vm.loading
                                    ? _c("div", { attrs: { id: "loading" } }, [
                                        _c("div", { staticClass: "loadingMsg" })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tab-content" }, [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "div",
                                          { staticClass: "alert alert-info" },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.cognitoIdProviderName
                                                ) +
                                                " ログインユーザーの登録を一括で実施することができます。"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                          登録するために必要なテンプレートCSVファイルは、”テンプレートのダウンロード”から取得してください。"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                          このアップロードでは、既に登録されているユーザー情報を変更することはできません。"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                          変更したいユーザーについては、削除を行ってから実施してください。\n                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "fallback" },
                                            [
                                              _c("p", { staticClass: "desc" }, [
                                                _vm._v(
                                                  "自分のコンピューターからファイルを選択する ："
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "btn-upload",
                                                  attrs: { for: "file_csv" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                              CSVファイルを選択\n                              "
                                                  ),
                                                  _vm.cognitoIdProviderName ===
                                                  "SAML"
                                                    ? _c("input", {
                                                        ref: "myFiles",
                                                        staticClass:
                                                          "custom-file-input",
                                                        staticStyle: {
                                                          display: "none"
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.isSamlFederatedLoginService ===
                                                            "false",
                                                          type: "file",
                                                          id: "file_csv",
                                                          multiple: "",
                                                          accept: ".csv"
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.previewFiles
                                                        }
                                                      })
                                                    : _c("input", {
                                                        ref: "myFiles",
                                                        staticClass:
                                                          "custom-file-input",
                                                        staticStyle: {
                                                          display: "none"
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.isFederatedLoginService ===
                                                            "false",
                                                          type: "file",
                                                          id: "file_csv",
                                                          multiple: "",
                                                          accept: ".csv"
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.previewFiles
                                                        }
                                                      })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "filename" },
                                                [_vm._v("選択されていません")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "error"
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                attrs: { id: "result" }
                                              }),
                                              _vm._v(" "),
                                              _vm.cognitoIdProviderName ===
                                              "SAML"
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isSamlFederatedLoginService ===
                                                          "false",
                                                        type: "button",
                                                        "data-toggle": "modal"
                                                      },
                                                      on: {
                                                        click: _vm.importExe
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                              登録データのアップロード\n                            "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isFederatedLoginService ===
                                                          "false",
                                                        type: "button",
                                                        "data-toggle": "modal"
                                                      },
                                                      on: {
                                                        click: _vm.importExe
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                              登録データのアップロード\n                            "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tab-content" }, [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "div",
                                          { staticClass: "alert alert-info" },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.cognitoIdProviderName
                                                ) +
                                                " ログインユーザーの登録を一括で実施するテンプレートファイルをダウンロードできます。\n                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "fallback" },
                                            [
                                              _vm.cognitoIdProviderName ===
                                              "SAML"
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isSamlFederatedLoginService ===
                                                          "false",
                                                        type: "button",
                                                        "data-toggle": "modal"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.getDataForExport(
                                                            1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                              テンプレートのダウンロード\n                            "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isFederatedLoginService ===
                                                          "false",
                                                        type: "button",
                                                        "data-toggle": "modal"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.getDataForExport(
                                                            1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                              テンプレートのダウンロード\n                            "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        ])
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modal fade",
                          attrs: { id: "process", tabindex: "-1" }
                        },
                        [
                          _c("div", { staticClass: "modal-dialog" }, [
                            _c("div", { staticClass: "modal-content" }, [
                              _c("div", { staticClass: "modal-body" }, [
                                _c(
                                  "span",
                                  { staticClass: "progress-question" },
                                  [_vm._v("CSVファイルのアップロード")]
                                ),
                                _vm._v(" "),
                                _vm.message.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "progress",
                                        class: {
                                          "progress-striped": !_vm.success,
                                          active: !_vm.success
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "progress-bar",
                                            style: _vm.progressWidth
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  Math.round(_vm.progress)
                                                ) + "%"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          padding: "10px",
                                          border: "1px solid #ccc",
                                          color: "red",
                                          "margin-top": "10px"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(_vm.message)
                                          }
                                        })
                                      ]
                                    ),
                                _vm._v(" "),
                                _vm.successItem > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "success-label" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.totalDataRow) +
                                            "件中" +
                                            _vm._s(_vm.successItem) +
                                            "件をインポートしました。"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errorMessageExcel.length > 0
                                  ? _c("div", [
                                      _c(
                                        "span",
                                        { staticClass: "error-box-title" },
                                        [_vm._v("インポート失敗")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "error-box" },
                                        [
                                          _vm._l(
                                            _vm.errorMessageExcel,
                                            function(item) {
                                              return [
                                                _c("p", {
                                                  key: item,
                                                  domProps: {
                                                    innerHTML: _vm._s(item)
                                                  }
                                                })
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.message.length === 0 &&
                                _vm.errorMessageExcel.length === 0 &&
                                Math.round(_vm.progress) === 100 &&
                                _vm.successItem === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "success-label" },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(_vm.totalDataRow) +
                                            "件中" +
                                            _vm._s(_vm.totalDataRow) +
                                            "件をインポートしました。\n                        "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "modal-footer" }, [
                                _vm.success
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-success pull-right",
                                        staticStyle: { width: "100px" },
                                        attrs: { "data-dismiss": "modal" },
                                        on: {
                                          click: function($event) {
                                            _vm.reset()
                                          }
                                        }
                                      },
                                      [_vm._v("OK")]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [_vm._v("システム設定")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("システム設定")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "150px" } }, [
      _c("b", [_vm._v("NFCカード動作設定")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("読み取り位置")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("固定コード有効・無効")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "150px" } }, [
      _c("b", [_vm._v("固定コード")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("Felica認証情報")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("MIFARE認証情報")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [_c("h3", [_vm._v("設定")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [_c("h3", [_vm._v("設定")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [_c("h3", [_vm._v("設定")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "center" }, [_vm._v("照合ログID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ログ名称")]),
        _vm._v(" "),
        _c("th", { staticClass: "center", staticStyle: { width: "110px" } }, [
          _vm._v("アクション")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("照合ログID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ログ名称")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tbody", [
      _c("tr", [
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v("該当するデーターがありません。")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("システム設定")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("SAML でログイン")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("Google でログイン")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("AppleID でログイン")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("ログインユーザーを削除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("span", { staticClass: "progress-question" }, [
        _vm._v(" ログインユーザーを削除しますか？")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96e50ff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96e50ff6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/SettingList.vue
// module id = null
// module chunks = 